import { SemiCircle } from "@components/background/semi_circle";
import { PopupError } from "@components/general/popup";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import {
  FcBusinessContact,
  FcCalendar,
  FcGraduationCap,
  FcHighPriority,
  FcList,
  FcMoneyTransfer,
  FcPlus,
  FcSettings,
  FcShop,
  FcTodoList,
} from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const MenuPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state,
  );

  const [popupError, setPopupError] = useState<boolean>(false);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Menu",
      image: false,
    });
    setAppBar({
      title: "Menu",
      show: true,
      leading: "back",
    });
    setBottomNavigation("hidden");
  }, [setHeader, setAppBar, setBottomNavigation]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <SemiCircle />
        <div className="tw-px-0 card-body">
          <div className="tw-px-4 tw-mb-2">
            <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Sekolah
            </div>
          </div>
          <div className="tw-mb-2 menu">
            <div className="card-body-grid">
              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div onClick={() => navigate(linkPage.INFO_BIOGRAPH)}>
                  <div className="bg-rotated tw-absolute tw-bg-[#f5e9ff]" />
                  <FcBusinessContact className="card-icon tw-text-accent-primary" />
                  <div className="card-name">Biodata</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div onClick={() => navigate(linkPage.HEALTH_PAGE)}>
                  <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
                  <FcPlus className="card-icon tw-text-[#00b894] tw-relative tw-z-10" />
                  <div className="tw-line-clamp-1 card-name">Kesehatan</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div onClick={() => navigate(linkPage.ABSENCE_PAGE)}>
                  <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                  <FcList className="card-icon" />
                  <div className="card-name">Absensi</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.VIOLATION_PAGE)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                  <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
                  <div className="tw-line-clamp-1 card-name">Pelanggaran</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                  <FcGraduationCap className="card-icon tw-text-[#FF5C5C]" />
                  <div className="card-name">Prestasi</div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-px-4 tw-mb-2">
            <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Tahfidz
            </div>
          </div>
          <div className="tw-mb-2 menu">
            <div className="card-body-grid">
              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div onClick={() => navigate("/school/tahfidz")}>
                  <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
                  <FcTodoList className="card-icon tw-text-[#00b894]" />
                  <div className="card-name">Tahfidz</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div onClick={() => navigate("/school/tafaquh")}>
                  <div className="bg-rotated tw-absolute tw-bg-[#e4e8ff]" />
                  <FcTodoList className="card-icon tw-text-[#00b894]" />
                  <div className="card-name">Tafaquh</div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-px-4 tw-mb-2">
            <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Toko
            </div>
          </div>
          <div className="tw-mb-2 menu">
            <div className="card-body-grid">
              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.MARKETPLACE_PRODUCT)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                  <FcShop className="card-icon" />
                  <div className="card-name">Toko</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.MARKETPLACE_SETTING)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                  <FcSettings className="card-icon" />
                  <div className="card-name">Atur Limit</div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-px-4 tw-mb-2">
            <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Tagihan
            </div>
          </div>
          <div className="tw-mb-2 menu">
            <div className="card-body-grid">
              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                  <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
                  <div className="card-name">Bulanan</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                  <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
                  <div className="card-name">Non Bulanan</div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-px-4 tw-mb-2">
            <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Pembayaran
            </div>
          </div>
          <div className="tw-mb-2 menu">
            <div className="card-body-grid">
              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={
                    () =>
                      navigate(
                        linkPage.FINANCE_REQUEST_VA.replace(":type", "bill"),
                        {
                          state: {
                            tagihan: true,
                            tipe: "bill",
                          },
                        },
                      )
                    // setPopupError(true)
                  }
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
                  <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
                  <div className="card-name">Request VA</div>
                </div>
              </div>

              {/* <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={
                    () =>
                      navigate(
                        linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"),
                        {
                          state: {
                            tagihan: false,
                            tipe: "zis",
                          },
                        },
                      )
                    // setPopupError(true)
                  }
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
                  <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
                  <div className="card-name">VA ZIS</div>
                </div>
              </div> */}

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate("/finance/data-va")}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                  <FcList className="card-icon" />
                  <div className="card-name">Laporan VA</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                  <FcList className="card-icon" />
                  <div className="card-name">Laporan Uang Saku</div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-px-4 tw-mb-2">
            <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Perizinan
            </div>
          </div>

          <div className="tw-mb-2 menu">
            <div className="card-body-grid">
              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.PERMIT_PAGE)}
                  className="tw-m-0"
                >
                  <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                  <FcCalendar className="card-icon tw-text-[#ff6b6b]" />
                  <div className="card-name">Request Izin</div>
                </div>
              </div>

              <div className="tw-mx-2 tw-pb-2 card-grid">
                <div
                  onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
                  className="tw-m-0"
                >
                  <FcList
                    className="card-icon"
                    style={{ background: "#eee" }}
                  />
                  <div className="card-name">Laporan</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
